import Api from "../../config/ApiConfig";
import * as types from "./types";
import { IDataTargetPutReq } from "./types";
import * as functions from '../../components/shared/functions';

const apiUrls = {
    getDataTargetList: "api/v1/searches/targets",   
    getDataTargets: "api/v1/targets",
}

export const getDataTargetList = (params : types.ITargetListParams) => 
    Api.get<types.IDataTarget[]>(apiUrls.getDataTargetList + "?skip=" + params.skip + "&count=" + params.count + "&orderby=" + params.orderby +
    "&top="+ params.top + "&queryType=full&search=" + params.search + functions.getParam(params.layerType, "layerType") + functions.getParam(params.owner, "owner") + functions.getParam(params.endpoint, "endpoint")) 
            .then((response) => { return response })
            .catch((error) => { return error.response });   


export const getTargetDetails = (param: number) => 
    Api.get(apiUrls.getDataTargets + `/${param}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });
    
export const postDataTarget = (payload : types.IPostDataTargetReq) => 
    Api.post(apiUrls.getDataTargets, payload)
        .then((response) => { return response })
        .catch((error) => {return error.response });

export const deleteTarget = (param: number) => 
    Api.delete(apiUrls.getDataTargets + `/${param}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });
        
export const putDataTarget = (param: number, payload : IDataTargetPutReq) => 
    Api.put(apiUrls.getDataTargets + `/${param}`, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });
                
    